<template>
    <div class="row mx-1">
      <!--<div class="col-3 align-items-center">
        <label>Search</label>
        <div class="input-group">
        <span class="input-group-text text-body">
            <i class="fas fa-search" aria-hidden="true"></i>
        </span>
        <input type="text" class="form-control" placeholder="Search Top Up"  />
        </div>-->


        <!-- <label>Transaction Date:</label>
        <Datepicker
          v-model="filter.dateRange"
          :partial-range="false"
          :enable-time-picker="false"
          :clearable="false"
          :disable="loading"
          multi-calendars
          range
        /> -->
      <!--</div>-->
      <!--<div class="col-3 d-flex align-items-end">
        <button
          class="btn bg-gradient-dark mb-0"
          :disable="loading"
          @click="getTransactions"
        >
          <i class="fas fa-search" v-if="!loading"></i>
          <i class="fa-solid fa-spinner fa-spin-pulse" v-if="loading"></i>
          Search
        </button>
      </div>-->
      <div class="col-12 d-flex align-items-end">
      
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  export default {

  };
  </script>
  
  <style>
  </style>